module.exports = __webpack_public_path__ + "static/attachment03-6af645ee6181c955d4f6c8f4dec63e0f.jpg";